import React from "react";
import { motion } from "framer-motion";
import { RELEASES } from "../data/content";

export default function StatsStrip() {
  const total = RELEASES.length;
  const albums = RELEASES.filter((r) => r.type === "Album").length;
  const eps = RELEASES.filter((r) => r.type === "EP").length;
  const singles = RELEASES.filter((r) => r.type === "Single").length;
  const yearsActive = (() => {
    const years = RELEASES.map((r) => parseInt(r.year, 10)).filter(Boolean);
    if (!years.length) return 0;
    return Math.max(...years) - Math.min(...years) + 1;
  })();

  const stats = [
    { label: "Total Releases", value: String(total).padStart(2, "0") },
    { label: "Albums", value: String(albums).padStart(2, "0") },
    { label: "EPs", value: String(eps).padStart(2, "0") },
    { label: "Singles", value: String(singles).padStart(2, "0") },
    { label: "Years Active", value: String(yearsActive).padStart(2, "0") },
  ];

  return (
    <section
      data-testid="stats-strip"
      className="relative py-10 md:py-14 border-t border-b border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-2 sm:grid-cols-5 gap-6 md:gap-10">
          {stats.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="relative"
            >
              <div className="font-display text-4xl md:text-5xl text-[#F5F5F0] tabular-nums leading-none">
                {s.value}
              </div>
              <div className="mt-2 text-[10px] uppercase tracking-[0.3em] text-[#C5A059]">
                {s.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
